import * as RTabs from "@radix-ui/react-tabs";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type PillTab = {
  value: string;
  label: ReactNode;
};

type PillTabsListProps = {
  tabs: readonly PillTab[];
  className?: string;
  triggerClassName?: string;
};

const BASE_TRIGGER_CLASSES =
  "flex h-8 items-center rounded px-2 text-sm font-semibold text-slate-900 transition-colors shadow-none hover:bg-slate-100 hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/30 data-[state=active]:bg-black data-[state=active]:text-white data-[state=active]:hover:bg-black data-[state=active]:shadow-sm";

export function PillTabsList({
  tabs,
  className,
  triggerClassName,
}: PillTabsListProps) {
  return (
    <RTabs.List
      className={cn("flex gap-1 sm:gap-2 min-w-max md:min-w-0", className)}
    >
      {tabs.map((tab) => (
        <RTabs.Trigger
          key={tab.value}
          value={tab.value}
          className={cn(BASE_TRIGGER_CLASSES, triggerClassName)}
        >
          {tab.label}
        </RTabs.Trigger>
      ))}
    </RTabs.List>
  );
}
